import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { StatusBadge } from "@/components/StatusBadge";
import { formatCurrency } from "@/lib/format";
import { useTranslation } from "react-i18next";

export default function SuperPlans() {
    const { t } = useTranslation();
    const [plans, setPlans] = useState([]);

    useEffect(() => { api.get("/billing/plans").then(({ data }) => setPlans(data)); }, []);

    return (
        <>
            <Topbar title={t("super_admin.plans_title")} subtitle={`${plans.length} ${t("common.total", "plans")}`} />
            <div className="flex-1 overflow-auto p-6">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                    {plans.map((p) => (
                        <div key={p.id} className="akm-card p-5" data-testid={`plan-card-${p.name.toLowerCase()}`}>
                            <div className="flex items-center justify-between">
                                <div className="text-sm font-semibold tracking-tight">{p.name}</div>
                                <StatusBadge status={p.is_active ? "active" : "skipped"} label={p.is_active ? "Active" : "Inactive"} />
                            </div>
                            <div className="mt-2 flex items-baseline gap-1">
                                <span className="text-2xl font-semibold tracking-tight">{formatCurrency(p.price_monthly, p.currency)}</span>
                                <span className="text-[11px] text-muted-foreground">/ month</span>
                            </div>
                            <ul className="mt-3 space-y-1 text-[12px] text-muted-foreground">
                                <li>Up to {p.max_properties} properties</li>
                                <li>Up to {p.max_rooms} rooms</li>
                                <li>Up to {p.max_users} users</li>
                            </ul>
                            <div className="mt-3 flex flex-wrap gap-1">
                                {p.modules.map((m) => (
                                    <span key={m} className="rounded-md bg-muted px-1.5 py-0.5 text-[10px] capitalize text-foreground">{m}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
